import React, { Component } from 'react'
import SmoothCollapse from 'react-smooth-collapse'
import Checkbox from 'components/input/checkbox'
import AlertBanner from 'components/alerts/alert-banner'

import ProjectProgressItem from './dashboard-project-progress-item'

import ProgressSlider from 'components/progress-slider/progress-slider'
import windowDimensions from 'react-window-dimensions'

import { 
    isMobile,
} from 'utils'

class DashboardProjectProgress extends Component {
    innerListRefs = []
    state = {
        isExpanded: false,
        isShowingAllStatuses: false,
        scrollLeft: 0,
        columns: 4
    }
    hasRequestedAllData = false

    UNSAFE_componentWillMount = _ => {
        this.recalcWidth()

        window.addEventListener("resize", this.recalcWidth)
    }

    componentWillUnmount = _ => {
        window.addEventListener("resize", this.recalcWidth)
    }

    recalcWidth = _ => {
        const screenWidth = this.props.width

        let columns = 4

        if(screenWidth > 1700){
            columns = 6
        }else if(screenWidth > 1430){
            columns = 5
        }

        if(this.state.columns !== columns){
            this.setState({
                columns
            })
        }
    }

    handleChangeExpanded = _ => {
        if(!this.hasRequestedAllData){
            this.hasRequestedAllData = true
            this.props.getAllProjectProgress(this.props.accountData.id, this.state.columns)
        }

        this.setState({
            isExpanded: !this.state.isExpanded
        })
    }

    handleChangeStatuses = _ => {
        this.setState({
            isShowingAllStatuses: !this.state.isShowingAllStatuses
        })
    }

    handleTouchMove = e => {
        if(this.listRef){
            this.setState({
                scrollLeft: this.listRef.scrollLeft,
            })
        }
    }

    shouldRenderProgressItem = (groups, index) => {
        let allItems = []

        groups.forEach(group => {
            allItems.push(group)
        })

        if(this.listRef){
            const firstElementWidth = 300

            const leftThresholdPx = this.listRef.scrollLeft - 50
            const rightThresholdPx = leftThresholdPx + 500 + 100

            const elementLeft = (firstElementWidth + 20) * index
            const elementRight = elementLeft + firstElementWidth + 20

            if(elementRight > leftThresholdPx && elementLeft < rightThresholdPx){
                return true
            }else{
                return false
            }
        }

        return true
    }

    render(){
        const {
            scrollLeft,
            isExpanded,
            isShowingAllStatuses,
            columns
        } = this.state

        const {
            allProjects,
            allFolders,
            projectIds,
            accountProjects
        } = this.props

        let totalProjects = accountProjects.length

        let firstGroup = []
        let restofProjects = []
        let hasData = false
        let willShowTiming = false 

        // these 2 loops can be consolidated
        projectIds.forEach(projectId => {
            const projectObject = allProjects[projectId]

            if(!projectObject){
                return
            }

            if(projectObject.estimatedMinutes || projectObject.trackedMinutes){
                willShowTiming = true
            }

            const parentFolderObject = allFolders[projectObject.folder_id]

            const parentFolderName = parentFolderObject ? parentFolderObject.name : null

            if(parentFolderName !== 'Templates'){
                hasData = true

                if(firstGroup.length < columns){
                    firstGroup.push(projectObject)
                }else{
                    restofProjects.push(projectObject)
                }
            }
        })

        accountProjects.forEach(project => {
            if(projectIds.indexOf(project.id) === -1){
                if(!project){
                    return
                }

                if(project.estimatedMinutes || project.trackedMinutes){
                    willShowTiming = true
                }

                restofProjects.push(project)
            }
        })

        const loopGroups = [
            firstGroup, restofProjects
        ]

        let totalVisibleGroups = loopGroups[0].length

        if(isExpanded){
            totalVisibleGroups += loopGroups[1].length
        }

        let itemIndex = -1

        return(
            <div className={"dashboard-project-progress columns-"+columns}>
                <h3>
                    Project progress
                    <div className="controls relative">
                        { !isMobile() ?
                        <label>
                            <Checkbox
                                isChecked={isShowingAllStatuses}
                                onChange={this.handleChangeStatuses}
                            />
                            Include all statuses 
                        </label>
                        : null }
                        { totalProjects > columns ? 
                            <label>
                                <Checkbox 
                                    isChecked={isExpanded} 
                                    onChange={this.handleChangeExpanded} 
                                />
                                Show all
                            </label>
                        : null }
                    </div>
                </h3>
                {
                    hasData ?    
                    <ul 
                        className="project-progress-list"
                        onScroll={e => {
                            this.handleTouchMove(e)
                        }}
                        ref={ref => this.listRef = ref}
                    >
                        {
                            loopGroups.map((group, index) => {

                                let isExpanded = true;
    
                                if(index == 1){
                                    isExpanded = this.state.isExpanded;
                                }
    
                                return (
                                    <div 
                                        className={isExpanded ? 'expanded' : null} 
                                        key={index}
                                        ref={ref => this.innerListRefs[index] = ref}
                                    >
                                        <SmoothCollapse 
                                            expanded={isExpanded}
                                            className="progress-smooth-collapse"
                                        >
                                            {
                                                group.map((project, index) => {

                                                    itemIndex += 1

                                                    let shouldRender = isMobile() ? this.shouldRenderProgressItem(loopGroups, itemIndex) : true

                                                    if(shouldRender){   
                                                        return (
                                                            <ProjectProgressItem 
                                                                project={project} 
                                                                key={index} 
                                                                isShowingTiming={willShowTiming}
                                                                isShowingAllStatuses={isShowingAllStatuses}
                                                            />
                                                        )                                              
                                                    }else{
                                                        return (
                                                            <li key={index} className="project-progress-item"></li>
                                                        )
                                                    }
                                                })
                                            }
                                        </SmoothCollapse>
                                    </div>
                                )
                            })
                        }
                    </ul>
                    : 
                    <AlertBanner 
                        low={false} 
                        title={`Not enough data yet.`} 
                        body="Add some projects to get started!" 
                    />
                }
                { isMobile() && totalProjects >= 3 &&
                    <ProgressSlider 
                        listRef={this.listRef} 
                        innerListRefs={this.innerListRefs} 
                        scrollLeft={scrollLeft} 
                        loopGroups={loopGroups}
                        totalItems={totalVisibleGroups}
                    />
                }
            </div>
        )
    }
}

export default windowDimensions()(DashboardProjectProgress)